import ProfileModel from "../../../../Profile/Models/ProfileModel";

export default class UserListWinners {
  public position: string = "";
  public profileId: string = "";
  public profileModel: ProfileModel = null;
  public note: string = "";
  public tags: string[] = [];
}
